<div class="thank-you-container">
    <div class="header">
        <img class="logo" [src]="thankyouImg" alt="" srcset="">
    </div>
    <div class="content">
        <div>
            <h1 class="text-center">
                {{thankyouLabels?.thankyouHeader ?? 'THANK YOU'}}
            </h1>
            <p class="text-center">
                {{thankyouLabels?.thankyouBody ?? 'for using our Service. Click below to start again'}}
            </p>
            <div class="d-flex justify-content-center">
                <button type="button" class="btn update-btn button-shadow mb-2" (click)="startApp()">
                    {{thankyouLabels?.thankyouButtonText ?? "Let's go"}}
                    <mat-icon>arrow_right_alt</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>